import type { EdgeId } from '@ipfabric/utils';
import type { DeviceViewElementType } from 'components/DeviceView/deviceViewTypes';
import { highlightEdge } from 'components/Graph/commands/edges/highlightEdge';
import {
  EDGE_HIGHLIGHT_COLOR,
  EDGE_HIGHLIGHT_THICKNESS,
} from 'components/Graph/constants';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface PathLookupDetailHoverCommand {
  detailId: EdgeId;
  deviceViewElement: DeviceViewElementType;
}

export const pathLookupDetailHover: GraphCommandFactory<
  PathLookupDetailHoverCommand
> = (cmdContext, dispatch) => (command) => {
  const { activeNodeSn, highlightedEdges, selectedPackets } =
    cmdContext.getState().pathlookup.pathInspector;
  // Highlight edge if detail is path lookup edge detail
  // of if path inspector node has one of edges to highlight
  if (
    command.deviceViewElement === 'packetDetails' ||
    (command.deviceViewElement === 'node' &&
      (Object.keys(selectedPackets).length === 0 ||
        (activeNodeSn !== null &&
          highlightedEdges[activeNodeSn] !== undefined &&
          !highlightedEdges[activeNodeSn]?.incomingEdges.includes(
            command.detailId,
          ) &&
          !highlightedEdges[activeNodeSn]?.outgoingEdges.includes(
            command.detailId,
          ))))
  ) {
    dispatch(highlightEdge, {
      color: EDGE_HIGHLIGHT_COLOR,
      thickness: EDGE_HIGHLIGHT_THICKNESS,
      edgeId: command.detailId,
    });
  }
};
